import _ from "lodash";
import vm from "../main";
import { httpClient as http } from ".";

const internals = {};

internals.getSyncWithTraccar = (Id) => {
  
  return http
    .post(`/syncTraccar`)
    .then((response) => {
     
      return response;
    })
    .catch((error) => {
      console.error("Sync With Traccar Service-error:\n", error);
      throw error;
    });
};

export default internals;



// WEBPACK FOOTER //
// ./src/services/syncWithTraccar.service.js